import moment from 'moment'
import React, { PureComponent } from 'react'
import { Table } from "antd";

import { Detection, Camera } from '../../types';
import Datafetcher from '../../utils/datafetcher';


interface Props {
    activeCam: Camera
    datafetcher: Datafetcher
}

interface State {
    messages: Detection[]
}

const capitalize = (e: string) => e.charAt(0).toUpperCase() + e.slice(1)

export default class StripePaymentSaver extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { messages: [] }
    }

    componentDidMount() {
        this.setState({ messages: [] })
        this.getHistory(this.props.activeCam)
    }

    componentDidUpdate(oldProps: Props) {
        if (this.props === oldProps) { return }
        this.getHistory(this.props.activeCam)
    }

    getHistory(activeCam : Camera) {
        const { datafetcher } = this.props;

        if (!activeCam) { return [] }
        datafetcher.getLogs(activeCam.id, (err: Error | null, resp: { data: Detection[] | null } | null) => {
            if (!resp) { return }
            this.setState({ messages: resp && resp.data ? resp.data : [] })
        })
    }

    getTableData = () => {
        if (!this.state.messages) { return [] }
        const copy: Detection[] = JSON.parse(JSON.stringify(this.state.messages))
        const results: Detection[] = []
        copy.forEach((message) => {
            results.push(message)
            results[results.length - 1].detector = capitalize(message.detector)
            results[results.length - 1].timestamp = moment(message.timestamp.slice(0, -1)).from(moment())
        })
        return results
    }

    render() {
        return <Table
            pagination={{ pageSize: 6 }}
            columns={[
                {
                    title: 'Object',
                    dataIndex: 'detector',
                    key: 'detector',
                },
                {
                    title: 'Timestamp',
                    dataIndex: 'timestamp',
                    key: 'timestamp',
                    defaultSortOrder: 'descend',
                    sorter: (a: Detection, b: Detection, _: any) => new Date(a.timestamp) >= new Date(b.timestamp) ? -1 : 1,
                },
            ]}
            dataSource={this.getTableData()} />
    }

}